import { render, staticRenderFns } from "./ToggleFilterBtn.vue?vue&type=template&id=2e71a549&"
import script from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardHeader/ToggleFilterBtn?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardHeader/ToggleFilterBtn?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports